import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';

import { Step, Steps } from '@feathr/components';
import { StoresContext, useLocalUrl } from '@feathr/extender/state';

import BillableStepFour from './BillableStepFour';
import BillableStepOne from './BillableStepOne';
import BillableStepThree from './BillableStepThree';
import BillableStepTwo from './BillableStepTwo';

import * as styles from './BillableAdd.css';

function BillableAdd() {
  const { Billables } = useContext(StoresContext);
  const history = useHistory();
  const localUrl = useLocalUrl();
  const [billable] = useState(Billables.create());
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <div className={styles.root}>
      <Steps className={styles.steps} current={currentStep}>
        <Step title={'Contact information'} />
        <Step title={'Billing address'} />
        <Step title={'Payment method'} />
        <Step title={'Description'} />
      </Steps>

      {currentStep === 0 && (
        <BillableStepOne billable={billable} onNext={() => setCurrentStep(currentStep + 1)} />
      )}

      {currentStep === 1 && (
        <BillableStepTwo
          billable={billable}
          onNext={() => setCurrentStep(currentStep + 1)}
          onPrevious={() => setCurrentStep(currentStep - 1)}
        />
      )}

      {currentStep === 2 && (
        <BillableStepThree
          billable={billable}
          onNext={() => setCurrentStep(currentStep + 1)}
          onPrevious={() => setCurrentStep(currentStep - 1)}
        />
      )}

      {currentStep === 3 && (
        <BillableStepFour
          billable={billable}
          onPrevious={() => setCurrentStep(currentStep - 1)}
          onSave={() => {
            history.push(localUrl('/settings/billing/configurations'));
          }}
        />
      )}
    </div>
  );
}

export default observer(BillableAdd);
